import React, { memo } from 'react';
import { BorderRadiusTokens, ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, ProgressIndicatorTypeTokens, ShadowTypeTokens, SizeTypeTokens, StackJustifyContent, StackWidth, TypographyTypeDLS, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import { ImageBackground, View } from 'react-native';
import { ProgressIndicator } from '../progressIndicator/ProgressIndicator';
import { Stack } from '../stack/Stack';
import Divider from '../divider/Divider';
import { TypographyBaseDLS } from '../typography/TypographyDLS.base';
import ButtonDLSBase from '../button/ButtonDLS.base';
import { isFontMobile } from '../stack/utils';
import { isFromTDLPlatform } from '../pages/utils';
/**
 * Primary UI component for user interaction
 */
const AmountCardWallet = ({ id, title, subTitle, progressLabel, warning, subscriptTitle, bgColor = ColorTokens.White, icon = {
    name: IconTokens.Info,
    size: IconSizeTokens.XS,
    align: IconAlignmentTokens.left,
}, progressFillPercentage, metaData, repayMessage, repayAmount, repayAction, withdrawAction, triggerAction, typeWithdrawButton, 
// loading,
newWithdrawFlow, disableRepayAndWihtdraw, }) => {
    const isfromTDL = isFromTDLPlatform();
    const imageCard = () => {
        return (React.createElement(ImageBackground, { source: {
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bg_img.png',
            }, resizeMode: "cover", imageStyle: { borderTopLeftRadius: 16, borderTopRightRadius: 16 }, style: { width: '100%', height: 102 } },
            React.createElement(View, { style: { padding: 16, marginBottom: 10 } },
                React.createElement(TypographyBaseDLS, { label: title, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Secondary_100, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(TypographyBaseDLS, { id: id, label: subTitle, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_100 })))));
    };
    const neuCard = () => {
        return (React.createElement(View, { style: { padding: 16, marginBottom: 10 } },
            React.createElement(TypographyBaseDLS, { label: title, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
            React.createElement(Space, { size: SizeTypeTokens.XS }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                } },
                React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Secondary_100, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                React.createElement(TypographyBaseDLS, { id: id, label: subTitle, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_100 }))));
    };
    const newWalletCard = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    ...isfromTDL && { borderWidth: 1 },
                    borderRadius: isfromTDL ? 12 : 16,
                    borderColor: '#F1F3F5',
                    width: '100%', backgroundColor: 'white',
                } },
                isfromTDL ? neuCard() : imageCard(),
                React.createElement(View, { style: { width: '100%', backgroundColor: isfromTDL ? '#F5F5F5' : 'white', borderBottomLeftRadius: isfromTDL ? 12 : 16, borderBottomRightRadius: isfromTDL ? 12 : 16, ...isfromTDL && { borderWidth: 1, borderTopWidth: 0, borderColor: '#F1F3F5' } } },
                    React.createElement(View, { style: { marginBottom: 12 } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16 } },
                        React.createElement(TypographyBaseDLS, { label: repayMessage, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                            React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: isFontMobile() ? FontSizeTokens.MD : FontSizeTokens.SM, lineHeight: isFontMobile() ? 24 : 20 }),
                            React.createElement(View, { style: { marginTop: 2 } },
                                React.createElement(TypographyBaseDLS, { label: repayAmount === null || repayAmount === "null" ? "0" : repayAmount, typeDLS: TypographyTypeDLS.H4B, color: ColorTokens.Grey_Night })))))),
            React.createElement(View, { style: { marginTop: 12, flexDirection: 'row', justifyContent: 'space-between', display: 'flex', width: '100%' } },
                React.createElement(View, { style: { flex: 1, marginRight: 12 } },
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.LARGE, typeDLS: ButtonTypeDLS.SECONDARY, label: "Repay", onPress: () => {
                            triggerAction({
                                ...repayAction
                            });
                        }, isDisabled: repayAmount === null || repayAmount === "null" || repayAmount === '0' || repayAmount === undefined || repayAmount?.includes('-') || disableRepayAndWihtdraw === true })),
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.LARGE, typeDLS: ButtonTypeDLS.PRIMARY, label: "Withdraw", onPress: () => {
                            triggerAction({
                                ...withdrawAction
                            });
                        }, isDisabled: (typeWithdrawButton === ButtonTypeTokens.LargeOutline || disableRepayAndWihtdraw === true) ? true : false })))));
    };
    const oldWalletCard = () => {
        return (React.createElement(Stack, { padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
            }, width: StackWidth.MATCH_PARENT, bgColor: bgColor, borderConfig: {
                borderRadius: isfromTDL ? BorderRadiusTokens.BR3 : BorderRadiusTokens.BR4
            }, shadow: ShadowTypeTokens.E2, justifyContent: StackJustifyContent.center, metaData: metaData },
            React.createElement(View, { style: { width: '100%' } },
                React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Night }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        //justifyContent:"center"
                    } },
                    React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { id: id, label: subTitle, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Night }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                            alignItems: 'baseline',
                            marginBottom: -10,
                        } },
                        React.createElement(Typography, { label: subscriptTitle, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
                React.createElement(Typography, { label: progressLabel, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(ProgressIndicator, { activeIndex: 1, size: 1, type: ProgressIndicatorTypeTokens.default, color: ColorTokens.System_Happy, fillPercentage: progressFillPercentage, bgColor: ColorTokens.Secondary_10 })),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            warning ? (React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignSelf: 'center',
                    flex: 1,
                } },
                React.createElement(Icon, { name: IconTokens.InfoMessage, size: IconSizeTokens.SM, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { label: warning, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }))) : (React.createElement(React.Fragment, null))));
    };
    return (newWithdrawFlow ? newWalletCard() : oldWalletCard());
};
export default memo(AmountCardWallet);
export { AmountCardWallet };
